// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__14HM-","colMaxWidth":"Table_colMaxWidth__1DN29"};